module.exports = __webpack_public_path__ + "static/img/need-bg-01.4f7c089.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/need-bg-01.png
// module id = BjHA
// module chunks = 1